let nativeElements = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'span',
  'blockquote',
  'small',
  'strong',
];
const Text = props => {
  let Tag =
    Object.keys(props).filter(item => nativeElements.indexOf(item) !== -1)[0] ||
    'span';
  return <Tag {...props} />;
};
export default Text;



// WEBPACK FOOTER //
// ./components/translate/index.js